import { createSlice } from "@reduxjs/toolkit";
import config from "../utils/config";

// Define initial state
const initialState = {
  configValues: {
    google_api_key: config.GOOGLE_API_KEY,
    server_base_url: config.SERVER_BASE_URL,
    websocket_server_base_url: config.WEBSOCKET_SERVER_BASE_URL,
  },
};

// Create a slice
const configSlice = createSlice({
  name: "config",
  initialState,
  reducers: {
    setConfigValues: (state, action) => {
      state.configValues = action.payload;
    },
  },
});

// Export the actions and reducer
export const { setConfigValues } = configSlice.actions;
export default configSlice.reducer;
